<template>
  <div class="abnormal-container">
    <NoData :tips="tips" />
  </div>
</template>
<script>
import NoData from '@/components/NoData';
import { STATUS_NAME } from '@/constants/status';

const TIP = '网络异常';

export default {
  name: 'Abnormal',
  components: {
    NoData,
  },
  data() {
    return {
      tips: '',
    };
  },
  created() {
    const { code } = this.$route.query;
    this.tips = `${STATUS_NAME[code] || TIP}，请稍后重试`;
  },
};
</script>
